(() => {
  const initCarousel = (section) => {
    if (!section || section.dataset.mediaCarouselInitialized === 'true') return;
    section.dataset.mediaCarouselInitialized = 'true';

    const track = section.querySelector('.media-carousel__track');
    const videoSlides = Array.from(section.querySelectorAll('[data-autoplay-video="true"]'));
    if (!track || !videoSlides.length) return;

    const videos = videoSlides
      .map((slide) => slide.querySelector('.media-carousel__video'))
      .filter(Boolean);

    const playSlideVideo = (slide) => {
      const video = slide.querySelector('.media-carousel__video');
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const pauseSlideVideo = (slide) => {
      const video = slide.querySelector('.media-carousel__video');
      if (!video) return;
      video.pause();
    };

    let syncFrame = null;
    const queueSyncVisibleVideos = () => {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(() => {
        syncFrame = null;
        syncVisibleVideos();
      });
    };

    const syncVisibleVideos = () => {
      if (document.hidden) {
        videoSlides.forEach(pauseSlideVideo);
        return;
      }
      videoSlides.forEach((slide) => {
        const rect = slide.getBoundingClientRect();
        const visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
        const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
        const widthRatio = visibleWidth / rect.width;
        const heightRatio = visibleHeight / rect.height;
        const visibilityRatio = Math.min(widthRatio, heightRatio);
        if (visibilityRatio >= 0.55) {
          playSlideVideo(slide);
        } else {
          pauseSlideVideo(slide);
        }
      });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        () => queueSyncVisibleVideos(),
        { threshold: [0, 0.35, 0.6, 0.85] }
      );
      videoSlides.forEach((slide) => observer.observe(slide));
      videos.forEach((video) => video.addEventListener('loadeddata', queueSyncVisibleVideos));
      track.addEventListener('scroll', queueSyncVisibleVideos, { passive: true });
      document.addEventListener('visibilitychange', syncVisibleVideos);
      window.addEventListener('resize', queueSyncVisibleVideos);
      syncVisibleVideos();
    } else {
      syncVisibleVideos();
      videos.forEach((video) => video.addEventListener('loadeddata', queueSyncVisibleVideos));
      track.addEventListener('scroll', queueSyncVisibleVideos, { passive: true });
      window.addEventListener('scroll', queueSyncVisibleVideos, { passive: true });
      window.addEventListener('resize', queueSyncVisibleVideos);
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        if (!section.contains(event.target)) return;
        event.target.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
        queueSyncVisibleVideos();
      });
    }
  };

  const initAll = () => {
    document.querySelectorAll('[id^="media-carousel-"]').forEach(initCarousel);
  };

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[id^="media-carousel-"]');
      if (section) initCarousel(section);
    });
  }
})();
